import classNames from "classnames";
import RivalsLogo from "rivals/components/shared/Icons/RivalsLogo";
import styles from "./index.module.scss";
import strings from "./strings";
import { OwnProps } from "./types";

const { collegeProfile, highSchoolProfile } = strings;

const SocialHeader = ({ isCollegePlayer }: OwnProps): JSX.Element => {
  return (
    <div
      className={classNames(styles.socialHeaderContainer, {
        [styles.highSchool]: !isCollegePlayer,
        [styles.college]: isCollegePlayer
      })}
    >
      <div className={styles.logoContainer}>
        <RivalsLogo fill={styles.bone} />
      </div>
      <div className={styles.profileType}>
        {isCollegePlayer ? collegeProfile : highSchoolProfile}
      </div>
    </div>
  );
};

export default SocialHeader;
